import clone from 'lodash-es/clone';
import tinycolor from 'tinycolor2';

export function defaultLighten(color: string, ratio?: number) {
  return tinycolor(color)
    .lighten(ratio ?? 20)
    .toRgbString();
}
export function defaultDarken(color: string, ratio?: number) {
  return tinycolor(color)
    .darken(ratio ?? 20)
    .toRgbString();
}
export function defaultGetContrastText(color: string) {
  const current = tinycolor(color);
  return tinycolor.readability('white', current) <
    tinycolor.readability('black', current)
    ? 'black'
    : 'white';
}

export function getValueByPath(
  obj: Record<string, unknown>,
  path: string | string[],
  separator = '.',
): unknown {
  const actualPath = typeof path === 'string' ? path.split(separator) : path;
  if (typeof obj !== 'object' || !obj) {
    if (actualPath.length === 0) return obj;
    return undefined;
  }
  const currentStep = actualPath.shift() as string;
  if (actualPath.length === 0) return obj[currentStep];
  return getValueByPath(
    obj[currentStep] as Record<string, unknown>,
    actualPath,
    separator,
  );
}

export function setValueByPath(
  obj: Record<string, unknown>,
  path: string,
  value: unknown,
) {
  if (path === '') return value as Record<string, unknown>;

  const steps = path.split('.');
  if (steps.length === 0) {
    console.warn(`An empty path was provoided ${path}`);
    return null;
  }
  const originalClonedObject = clone(obj ?? {});
  let currentObj = originalClonedObject;
  for (let i = 0; i < steps.length - 1; i++) {
    if (!currentObj[steps[i]]) currentObj[steps[i]] = {};
    if (typeof currentObj[steps[i]] === 'object') {
      currentObj = currentObj[steps[i]] as Record<string, unknown>;
    } else {
      console.info({
        originalObject: obj,
        originalPath: path,
        currentObj,
        currentStep: steps[i],
      });
      throw new Error(
        `The provided path ${path} cannot be applied due to it is not an object's path.`,
      );
    }
  }
  currentObj[steps.pop() as string] = value;
  return originalClonedObject;
}
